import { render, staticRenderFns } from "./customer-select.vue?vue&type=template&id=548eff9d"
import script from "./customer-select.vue?vue&type=script&lang=js"
export * from "./customer-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports